// @flow
import React from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import EstimateBoxTemplate from 'components/estimate/EstimateBoxTemplate';
import EstimateBoxSections from 'containers/estimate/EstimateBoxSections';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const EstimateBox = ({ match }: Props) => {
  const { id } = match.params;

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <EstimateBoxTemplate>
        <Helmet>
          <title>견적서 등록 | 캐시바이</title>
        </Helmet>
        <EstimateBoxSections id={id} />
      </EstimateBoxTemplate>
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default EstimateBox;



// WEBPACK FOOTER //
// ./src/pages/EstimateBox.js